import { useSettings } from '../providers/settings.provider';
/**
 * @description Custom hook to access feature flags from the settings context.
 * @returns { \flags: Record<string, any>, loading: boolean, getFlagValue: (flagKey: string) => any, isFlagEnabled: (flagKey: string) => boolean ,isTestingEnv: boolean, refreshFlags: function }
 */
const useFlagsHook = () => {
  const { settings, loading, refetchFlags } = useSettings();
  // Check if there is a testing environment flag
  const isTestingEnv = !loading ? settings?.flags?.['TESTING_ENV'] : false;
  // If there is a testing env flag, check if the current hostname matches the testing env value
  const isMatchingDomain = isTestingEnv
    ? window.location.hostname === settings?.flags?.['TESTING_ENV']
    : null;
  const getFlagValue = (flagKey) => {
    const flags = settings.flags || {};
    // If testing environment flag is on and the domain matches, look for the flag with the TEST_ prefix,
    // otherwise look for the flag without the prefix
    const v =
      flags?.[`${isTestingEnv && isMatchingDomain ? 'TEST_' : ''}${flagKey}`] || null;
    return v;
  };

  const isFlagEnabled = (key) => {
    if (!key) {
      console.error('A flag name is required');
      return false;
    }
    const value = getFlagValue(key.toString().toUpperCase());
    return String(value) === '1';
  };

  return {
    flags: settings.flags || {},
    loading,
    getFlagValue,
    isFlagEnabled,
    refetchFlags,
    isTestingEnv,
    isMatchingDomain,
    isTestingDomain: isTestingEnv && isMatchingDomain,
  };
};

export default useFlagsHook;
